var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.64V20.36C13 20.86 13.548 21.166 13.974 20.906L20.492 16.922C20.6501 16.8256 20.7807 16.6901 20.8713 16.5287C20.962 16.3672 21.0096 16.1852 21.0096 16C21.0096 15.8148 20.962 15.6328 20.8713 15.4713C20.7807 15.3099 20.6501 15.1744 20.492 15.078L13.972 11.096C13.875 11.0372 13.7642 11.0051 13.6507 11.0032C13.5373 11.0013 13.4255 11.0296 13.3266 11.0852C13.2277 11.1407 13.1453 11.2215 13.0879 11.3194C13.0306 11.4172 13.0002 11.5266 13 11.64ZM9 6C7.67392 6 6.40215 6.52678 5.46447 7.46447C4.52678 8.40215 4 9.67392 4 11V21C4 22.3261 4.52678 23.5979 5.46447 24.5355C6.40215 25.4732 7.67392 26 9 26H23C24.3261 26 25.5979 25.4732 26.5355 24.5355C27.4732 23.5979 28 22.3261 28 21V11C28 9.67392 27.4732 8.40215 26.5355 7.46447C25.5979 6.52678 24.3261 6 23 6H9ZM6 11C6 10.2044 6.31607 9.44129 6.87868 8.87868C7.44129 8.31607 8.20435 8 9 8H23C23.7956 8 24.5587 8.31607 25.1213 8.87868C25.6839 9.44129 26 10.2044 26 11V21C26 21.7956 25.6839 22.5587 25.1213 23.1213C24.5587 23.6839 23.7956 24 23 24H9C8.20435 24 7.44129 23.6839 6.87868 23.1213C6.31607 22.5587 6 21.7956 6 21V11Z",
    fill: "#151D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.697aba69b17ec488cca66bb088fb0969.svg";
export { ForwardRef as ReactComponent };